export default __webpack_public_path__ + "static/media/intuit.f22e4473.png";